/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Min_Duration_LabelInputs */



/**
* | output |
* | --- |
* | "Minimum Event Duration (sec)" |
*
* @param {Edit_Event_Group_Min_Duration_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_min_duration_label = /** @type {((inputs?: Edit_Event_Group_Min_Duration_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Min_Duration_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée minimale de l'événement (sec)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mindestdauer des Ereignisses (Sek.)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata minima dell'evento (sec)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимальная продолжительность события (сек)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración mínima del evento (seg.)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最短事件持续时间（秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最小イベント継続時間（秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("न्यूनतम आयोजन अवधि (सेकंड)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração mínima do evento (segundos)")
	return /** @type {LocalizedString} */ ("Minimum Event Duration (sec)")
});